import { render } from "./ItemPricingComponent.vue?vue&type=template&id=d064d65e&scoped=true"
import script from "./ItemPricingComponent.vue?vue&type=script&lang=js"
export * from "./ItemPricingComponent.vue?vue&type=script&lang=js"

import "./ItemPricingComponent.vue?vue&type=style&index=0&id=d064d65e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d064d65e"]])

export default __exports__